module.exports = __webpack_public_path__ + "img/24.fb822cf0.jpg";